import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import { HashLink } from "react-router-hash-link";
import logo from "../assets/logo.png";

export default function Header() {
  const [open, setOpen] = useState(false);

  return (
    <header className="w-full relative z-[100] transition-all duration-300 font-[Poppins]">
      {/* MAIN NAVBAR CONTAINER */}
      <div className="mx-auto w-full md:w-[100%] mt-0 transition-all duration-300">
        <div className="bg-sky-500/100 backdrop-blur-lg border border-white/20 shadow-lg px-6 py-3 flex items-center justify-between md:rounded-2xl">

          {/* LOGO */}
            <img src={logo} alt="Adeya AI" className="h-9 w-auto md:h-11 object-contain drop-shadow-lg" />

          {/* DESKTOP MENU */}
          <nav className="hidden md:flex items-center gap-1 bg-white/100 border border-gray-200/50 p-1 rounded-full">
            <NavItem to="/">Home</NavItem>
            <NavItem to="/pricing">Pricing</NavItem>
            <NavItem to="/features">Features</NavItem>
            {/* <NavItem to="/solutions">Solutions</NavItem> */}
            <NavItem to="/about">About</NavItem>
          </nav>

          {/* ROI BUTTON (Desktop) */}
          <div className="hidden md:block">
            <HashLink
              smooth to="/pricing#roi_calculator"
              className="bg-black text-white px-6 py-2.5 rounded-full font-semibold hover:bg-gradient-to-r from-pink-500 to-violet-600 transition-all duration-300 hover:shadow-pink-200 hover:shadow-lg active:scale-95"
            >
              ROI Calculator
            </HashLink>
          </div>

          {/* MOBILE HAMBURGER TOGGLE */}
          <button
            className="md:hidden relative w-10 h-10 flex flex-col items-center justify-center gap-1.5 focus:outline-none"
            onClick={() => setOpen(!open)}
          >
            <span className={`h-0.5 w-6 bg-black transition-transform duration-300 ${open ? "rotate-45 translate-y-2" : ""}`} />
            <span className={`h-0.5 w-6 bg-black transition-opacity duration-300 ${open ? "opacity-0" : ""}`} />
            <span className={`h-0.5 w-6 bg-black transition-transform duration-300 ${open ? "-rotate-45 -translate-y-2" : ""}`} />
          </button>
        </div>
      </div>

      {/* MOBILE FULL-SCREEN MENU */}
      <div
        className={`fixed inset-0 bg-white/95 backdrop-blur-xl z-[-1] flex flex-col items-center justify-center gap-8 transition-all duration-500 md:hidden ${open ? "opacity-100 visible" : "opacity-0 invisible translate-y-[-20px]"
          }`}
      >
        <div className="flex flex-col gap-6 text-center w-full px-10">
          <NavItem to="/" onClick={() => setOpen(false)} mobile>Home</NavItem>
          <NavItem to="/pricing" onClick={() => setOpen(false)} mobile>Pricing</NavItem>
          <NavItem to="/features" onClick={() => setOpen(false)} mobile>Features</NavItem>
          {/* <NavItem to="/solutions" onClick={() => setOpen(false)} mobile>Solutions</NavItem> */}
          <NavItem to="/about" onClick={() => setOpen(false)} mobile>About</NavItem>

          <HashLink
            smooth to="/pricing#roi_calculator"
            className="mt-4 bg-gradient-to-r from-sky-500/100 to-violet-600 text-white py-4 rounded-2xl text-xl font-bold shadow-xl"
            onClick={() => setOpen(false)}
          >
            ROI Calculator
          </HashLink>
        </div>
      </div>
    </header>
  );
}

function NavItem({ to, children, onClick, mobile }) {
  return (
    <NavLink
      to={to}
      onClick={onClick}
      className={({ isActive }) =>
        `transition-all duration-300 ${mobile
          ? `text-2xl font-bold py-2 ${isActive ? "text-sky-500/100" : "text-gray-800"}`
          : `px-5 py-2 rounded-full text-sm font-semibold ${isActive ? "bg-gray-900 text-white shadow-sm" : "text-gray-600 hover:text-black hover:bg-white/40"
          }`
        }`
      }
    >
      {children}
    </NavLink>
  );
}